import { a as languages } from "../../core-8vQkh0Rd.js";
//#region src/prism/languages/csv.js
languages.csv = {
	"value": /[^\n,"]+|"(?:[^"]|"")*"(?!")/,
	"punctuation": /,/
};
//#endregion

//# sourceMappingURL=csv.js.map